export default __webpack_public_path__ + "static/media/FlechaAbajo.4108d6e5.svg";